import { useEffect, useRef, useState } from "react";
import { dragTemArquivos } from "../domain/arquivos-da-biblioteca";

type Entrada = {
  readonly ativo: boolean;
  readonly onSoltar: (arquivos: File[]) => void;
};

function tiposDoDrag(evento: DragEvent): readonly string[] {
  return Array.from(evento.dataTransfer?.types ?? []);
}

/**
 * Escuta o documento para o overlay nao "roubar" o arraste (portal fora da zona).
 */
export function useSoltarArquivos({ ativo, onSoltar }: Entrada) {
  const [sobre, setSobre] = useState(false);
  const profundidade = useRef(0);
  const onSoltarRef = useRef(onSoltar);
  onSoltarRef.current = onSoltar;

  useEffect(() => {
    if (!ativo) {
      profundidade.current = 0;
      setSobre(false);
      return;
    }

    function resetar() {
      profundidade.current = 0;
      setSobre(false);
    }

    function onDragEnter(evento: DragEvent) {
      if (!dragTemArquivos(tiposDoDrag(evento))) return;
      evento.preventDefault();
      profundidade.current += 1;
      setSobre(true);
    }

    function onDragOver(evento: DragEvent) {
      if (!dragTemArquivos(tiposDoDrag(evento))) return;
      evento.preventDefault();
      if (evento.dataTransfer) evento.dataTransfer.dropEffect = "copy";
    }

    function onDragLeave(evento: DragEvent) {
      if (profundidade.current === 0) return;
      evento.preventDefault();
      profundidade.current -= 1;
      if (profundidade.current <= 0) resetar();
    }

    function onDrop(evento: DragEvent) {
      if (!dragTemArquivos(tiposDoDrag(evento))) return;
      evento.preventDefault();
      resetar();
      const todos = Array.from(evento.dataTransfer?.files ?? []);
      if (todos.length > 0) onSoltarRef.current(todos);
    }

    document.addEventListener("dragenter", onDragEnter);
    document.addEventListener("dragover", onDragOver);
    document.addEventListener("dragleave", onDragLeave);
    document.addEventListener("drop", onDrop);
    return () => {
      document.removeEventListener("dragenter", onDragEnter);
      document.removeEventListener("dragover", onDragOver);
      document.removeEventListener("dragleave", onDragLeave);
      document.removeEventListener("drop", onDrop);
      resetar();
    };
  }, [ativo]);

  return { sobre };
}
